import type { WorkspaceField } from "@/lib/mlx-workspace-client";
import {
  columnWidthStyle,
  fluidColumnWidthStyle,
  usePersistedColumnSizing as useSharedPersistedColumnSizing,
} from "../../table-sizing";

// No "use client": a Server Component reads the grid's sizes from here to
// draw a static grid. The width styles and the sizing hook stay in the
// client module they come from.

export const TITLE_COLUMN_ID = "title";
export const ACTIONS_COLUMN_ID = "actions";

/** A body row's height: rows are `h-8`, so a static grid sets row `index` at `index * ROW_HEIGHT`. */
export const ROW_HEIGHT = 32;

/** The fixed actions column fits three icon buttons and does not resize. */
export const ACTIONS_COLUMN_SIZE = {
  size: 88,
  minSize: 88,
  maxSize: 88,
} as const;
/** The title column, shown when no field is the record's primary field. */
export const TITLE_COLUMN_SIZE = {
  size: 220,
  minSize: 140,
  maxSize: 520,
} as const;

export function columnIdForField(field: WorkspaceField) {
  return `field:${field.id}`;
}
export function defaultFieldWidth(field: Pick<WorkspaceField, "type">) {
  if (field.type === "date" || field.type === "datetime") return 140;
  if (
    field.type === "number" ||
    field.type === "currency" ||
    field.type === "percent"
  )
    return 120;
  if (field.type === "select") return 150;
  return 160;
}

/** A field column's default width and the bounds it resizes within. */
export function fieldColumnSize(field: Pick<WorkspaceField, "type">) {
  return { size: defaultFieldWidth(field), minSize: 96, maxSize: 560 };
}

export { columnWidthStyle, fluidColumnWidthStyle };

export function usePersistedColumnSizing(storageKey: string) {
  return useSharedPersistedColumnSizing(storageKey);
}
